import { forwardRef, useImperativeHandle } from 'react';

import { PartnerLookupWidget } from 'components/partner_lookup/PartnerLookupWidget';
import { Partner, PartnerApi } from 'apis/PartnerApi';
import { Modal } from 'components/modal_manager';
import { FormattedMessage } from 'react-intl';
import { useSuperState } from 'hooks';

export type PartnerLookupModalShowOptions = {
    destination?: string;
    partnerType?: number;
}

export type PartnerLookupModalHandle = {
    hide: () => void;
    show: (options?: PartnerLookupModalShowOptions) => Promise<Partner>;
    visible: boolean;
}

export const PartnerLookupModal = forwardRef<PartnerLookupModalHandle, any>((props, forwardedRef) => {

    const [state, setState, resetState] = useSuperState({
        destination: '/',
        loading: false,
        partnerType: 0,
        reject: Function(),
        resolve: Function(),
        visible: false
    });
    const { loading, partnerType, resolve, visible } = state;

    const handleSelect = async (partner: Partner) => {

        setState({ loading: true });

        try {

            const partnerId = partner.ID ?? partner.Id;
            await PartnerApi.SetSelectedPartner(partnerId);
            resolve(partner);
            window.location.href = state.destination;

        } catch {

            setState({ loading: false });

        }

    };

    const show = (options?: PartnerLookupModalShowOptions) => new Promise<Partner | null>((resolve, reject) => {

        const { destination = '/', partnerType = 0 } = options ?? {};

        setState({
            destination,
            partnerType,
            reject,
            resolve,
            visible: true
        });

    });

    const hide = () => {

        resolve(null);
        resetState();

    };

    useImperativeHandle(forwardedRef, () => ({
        hide,
        show,
        visible
    }));

    return (
        <Modal backdrop={'static'} className={'partner-lookup-modal'} onHide={hide} show={visible} size={'xl'}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {<FormattedMessage defaultMessage="Partner Lookup" id="partner_lookup.7135d3ea" />}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PartnerLookupWidget
                    disabled={loading}
                    onSelect={handleSelect}
                    partnerType={partnerType}
                />
            </Modal.Body>
        </Modal>
    );

});

PartnerLookupModal.displayName = 'PartnerLookupModal';